import {post} from "./base_yun";

export function postAdmin(data){
    return post('/api/v1/admin/auth/login',data)
}
